var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFireRedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.6903C0 5.23393 5.23394 0 11.6903 0C18.1467 0 23.3806 5.23393 23.3806 11.6903V12.3097C23.3806 18.7661 18.1467 24 11.6903 24C5.23394 24 0 18.7661 0 12.3097V11.6903Z",
    fill: "#E7000B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6904 6C12.119 7.68421 12.9761 9.05263 14.2619 10.1053C15.5476 11.1579 16.1904 12.3158 16.1904 13.5789C16.1904 14.7515 15.7163 15.876 14.8724 16.7051C14.0285 17.5342 12.8839 18 11.6904 18C10.497 18 9.35236 17.5342 8.50845 16.7051C7.66454 15.876 7.19043 14.7515 7.19043 13.5789C7.19043 12.8957 7.416 12.2308 7.83329 11.6842C7.83329 12.103 8.00261 12.5046 8.30401 12.8007C8.60541 13.0968 9.01419 13.2632 9.44043 13.2632C9.86667 13.2632 10.2755 13.0968 10.5769 12.8007C10.8782 12.5046 11.0476 12.103 11.0476 11.6842C11.0476 10.4211 10.0833 9.78947 10.0833 8.52632C10.0833 7.68421 10.619 6.84211 11.6904 6Z",
    stroke: "white",
    strokeWidth: 1.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireRedIcon);
export default __webpack_public_path__ + "static/media/fire_red_icon.64b42cecf2f40408643275642d5a2075.svg";
export { ForwardRef as ReactComponent };